import {
  DELETE_CATEGORY,
  DELETE_CATEGORY_FAILURE,
  DELETE_CATEGORY_SUCCESS,
} from './action';

const initialState = {
  loading: false,
  data: [],
  error: '',
};

const deleteCategoryReducer = (state = initialState, action) => {
  switch (action.type) {
    case DELETE_CATEGORY:
      return { ...state, loading: true };
    case DELETE_CATEGORY_SUCCESS:
      return { ...state, loading: false, data: action.payload, error: '' };
    case DELETE_CATEGORY_FAILURE:
      return { ...state, loading: false, data: [], error: action.payload };
    default:
      return state;
  }
};

export default deleteCategoryReducer;
